var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChooseBankVerificationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 7,
    fill: "url(#paint0_linear_11837_2752)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(3 3)",
    fill: "url(#paint1_linear_11837_2752)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 10L15 5L24.5 10V12H5.5V10ZM15 7.26L20.21 10H9.79L15 7.26ZM8 14H10V21H8V14ZM16 14V21H14V14H16ZM5.5 23V25H24.5V23H5.5ZM20 14H22V21H20V14Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11837_2752",
    x1: 30,
    y1: 15,
    x2: -4.49871e-8,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#192A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2364A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11837_2752",
    x1: 24,
    y1: 12,
    x2: -3.59897e-8,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#192A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2364A4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseBankVerificationIcon);
export default __webpack_public_path__ + "static/media/choose-bank-verification-icon.98e040d84cb782a5b9fab833645140de.svg";
export { ForwardRef as ReactComponent };